import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import perdenserImage from "../assets/images/perdenser.jpg";
import perdenser1 from "../assets/images/perdenser/perdenser1.jpg";
import perdenser2 from "../assets/images/perdenser/perdenser2.jpg";
import perdenser3 from "../assets/images/perdenser/perdenser3.jpg";
import perdenser4 from "../assets/images/perdenser/perdenser4.jpg";
import perdenser5 from "../assets/images/perdenser/perdenser5.jpg";
import perdenser6 from "../assets/images/perdenser/perdenser6.jpg";
import perdenser7 from "../assets/images/perdenser/perdenser7.jpg";
import proender5 from "../assets/images/proender/proender5.jpg";
import proender1 from "../assets/images/proender/proender1.jpg";
import proender2 from "../assets/images/proender/proender2.jpg";
import proender3 from "../assets/images/proender/proender3.jpg";
import perfiller1 from "../assets/images/perfiller/perfiller1.jpg";
import perfiller2 from "../assets/images/perfiller/perfiller2.jpg";
import perfiller3 from "../assets/images/perfiller/perfiller3.jpg";
import perfiller4 from "../assets/images/perfiller/perfiller4.png";
import angioClean1 from "../assets/images/angio_clean/angio_clean1.jpg";
import angioCobra from "../assets/images/angio_clean/cobra.jpg";
import angioHeadhunter from "../assets/images/angio_clean/headhunter.jpg";
import angioSim from "../assets/images/angio_clean/sim.jpg";
import angioVertebral from "../assets/images/angio_clean/vertebral.jpg";
import mic1 from "../assets/images/microcatheters/mic1.jpg";
import mic2 from "../assets/images/microcatheters/mic2.jpg";
import mic3 from "../assets/images/microcatheters/mic3.jpg";
import hydra1 from "../assets/images/hydra/hydra1.jpg";
import neuroSoft1 from "../assets/images/neuro_soft/neuro_soft1.jpg";
import neuroSoft2 from "../assets/images/neuro_soft/neuro_soft2.jpg";
import neuroCathSupport1 from "../assets/images/neuro_cath_support/neuro_cath_support1.jpg";
import neuroCathSupport2 from "../assets/images/neuro_cath_support/neuro_cath_support2.jpg";
import neuroCathSupport3 from "../assets/images/neuro_cath_support/neuro_cath_support3.jpg";
import neurocathPlus1 from "../assets/images/neurocath_plus/neurocath_plus1.jpg";
import neurocathPlus2 from "../assets/images/neurocath_plus/neurocath_plus2.jpg";
import neurosheathHero from "../assets/images/neurosheath/neurosheath1.jpg";
import neurosheathStainless from "../assets/images/neurosheath/stainless_steel1.jpg";
import neurosheathDilator from "../assets/images/neurosheath/dilator1.jpg";
import neurosheathPt from "../assets/images/neurosheath/Pt1.jpg";
import neurosheathY from "../assets/images/neurosheath/y1.jpg";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";
import proenderPDF from "../assets/pdfs/proender.pdf";
import perdenserPDF from "../assets/pdfs/perdenser.pdf";
import perfillerPDF from "../assets/pdfs/perfiller.pdf";
import proenderIFUPDF from "../assets/pdfs/proender_ifu.pdf";
import perdenserIFUPDF from "../assets/pdfs/perdenser_ifu.pdf";
import perfillerIFUPDF from "../assets/pdfs/perfiller_ifu.pdf";
import neurocathPlusPDF from "../assets/pdfs/neurocathplus_br.pdf";
import neurocathSupportPDF from "../assets/pdfs/neurocathsupport_br.pdf";
import microcathetersPDF from "../assets/pdfs/microcatheters_br.pdf";
import neurosheathPDF from "../assets/pdfs/neurosheath_br.pdf";
import neurosoftPDF from "../assets/pdfs/neurosoft_br.pdf";
import hydraPDF from "../assets/pdfs/hydra_br.pdf";
import angiocleanPDF from "../assets/pdfs/angioclean_br.pdf";
import neurocathPlusIFUPDF from "../assets/pdfs/neurocathplus_ifu.pdf";
import neurocathSupportIFUPDF from "../assets/pdfs/neurocathsupport_ifu.pdf";
import microcathetersIFUPDF from "../assets/pdfs/microcatheters_ifu.pdf";
import neurosoftIFUPDF from "../assets/pdfs/neurosoft_ifu.pdf";
import angiocleanIFUPDF from "../assets/pdfs/angioclean_ifu.pdf";
import hydraIFUPDF from "../assets/pdfs/hydra_ifu.pdf";
import neurosheathIFUPDF from "../assets/pdfs/neurosheath_ifu.pdf";
import { Link, useLocation } from "react-router-dom";

function Products() {
  const location = useLocation();
  const [selectedProduct, setSelectedProduct] = useState("proender");
  const [activeTab, setActiveTab] = useState("specifications");
  const [currentPage, setCurrentPage] = useState(1);
  const [coilType, setCoilType] = useState("3D");
  const [microVariant, setMicroVariant] = useState("neurocath-17");
  const [microActiveTab, setMicroActiveTab] = useState("specifications");
  const itemsPerPage = 20;

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const productParam = params.get("product");
    if (productParam && products[productParam]) {
      setSelectedProduct(productParam);
      window.scrollTo({ top: 0, behavior: "smooth" });
    }
  }, [location]);

  // Helper functions for pagination
  const getCurrentItems = (items) => {
    const indexOfLastItem = currentPage * itemsPerPage;
    const indexOfFirstItem = indexOfLastItem - itemsPerPage;
    return items.slice(indexOfFirstItem, indexOfLastItem);
  };

  const totalPages = (items) => Math.ceil(items.length / itemsPerPage);

  const products = {
    proender: {
      title: "Proender®",
      subtitle: "Disposable Embolic Protection Device",
      description: "Embolic Protection Device",
      specs: [
        {
          catalogNo: "TJEP03-190",
          diameter: "3",
          length: "190",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP04-190",
          diameter: "4",
          length: "190",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP05-190",
          diameter: "5",
          length: "190",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP06-190",
          diameter: "6",
          length: "190",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP07-190",
          diameter: "7",
          length: "190",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP08-190",
          diameter: "8",
          length: "190",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP03-320",
          diameter: "3",
          length: "320",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP04-320",
          diameter: "4",
          length: "320",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP05-320",
          diameter: "5",
          length: "320",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP06-320",
          diameter: "6",
          length: "320",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP07-320",
          diameter: "7",
          length: "320",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
        {
          catalogNo: "TJEP08-320",
          diameter: "8",
          length: "320",
          compatibility: '0.014"',
          sheath: "3.2F",
          retrievalSheath: "4.2F",
          guidingCatheter: '0.066"',
        },
      ],
      features: [
        {
          title: "Effective Mesh Design",
          description:
            "The gradual filter mesh hole (effectively catching thrombus 80-240um) ensures the good debris capturing performance as well as continuous blood flow. While effectively capturing the emboli, it reduces the barrier to the blood flow, so that the blood flow can be continuously perfused.",
          image: proender1,
        },
        {
          title: "Soft and safe structure",
          description:
            "The unique seam-locking structure makes the opening shape full and can naturally fit with the blood vessel wall. The soft guide wire tip and round ball cap protect the distal blood vessels from damage to the utmost extent.",
          image: proender2,
        },
        {
          title: "Independently Moving Guide Wire Structure",
          description:
            "The unique fixed sleeve design allows the guide wire to perform 360-degree rotation and a certain range of axial movement; at the same time, it prevents the position of the released filter from changing, avoiding damage to the inner wall of the blood vessel or inducing vasospasm.",
          image: proender3,
        },
      ],
    },
    perrdenser: {
      title: "Perdenser™",
      subtitle: "Peripheral Drug-Eluting Balloon",
      description: "3D Perdenser Detachable Coil",
      image: perdenserImage,
      specs: [
        // Group 1: 1.5mm - 3mm Loop Dia.
        {
          catalogNo: "TJCST1.502-2D",
          catalogNo3D: "TJCST1.502-3D",
          loopDia: "1.5",
          length: "2",
        },
        {
          catalogNo: "TJCST1.503-2D",
          catalogNo3D: "TJCST1.503-3D",
          loopDia: "1.5",
          length: "3",
        },
        {
          catalogNo: "TJCST1.504-2D",
          catalogNo3D: "TJCST1.504-3D",
          loopDia: "1.5",
          length: "4",
        },
        {
          catalogNo: "TJCST0201-2D",
          catalogNo3D: "TJCST0201-3D",
          loopDia: "2",
          length: "1",
        },
        {
          catalogNo: "TJCST0202-2D",
          catalogNo3D: "TJCST0202-3D",
          loopDia: "2",
          length: "2",
        },
        {
          catalogNo: "TJCST0203-2D",
          catalogNo3D: "TJCST0203-3D",
          loopDia: "2",
          length: "3",
        },
        {
          catalogNo: "TJCST0204-2D",
          catalogNo3D: "TJCST0204-3D",
          loopDia: "2",
          length: "4",
        },
        {
          catalogNo: "TJCST0206-2D",
          catalogNo3D: "TJCST0206-3D",
          loopDia: "2",
          length: "6",
        },
        {
          catalogNo: "TJCST0208-2D",
          catalogNo3D: "TJCST0208-3D",
          loopDia: "2",
          length: "8",
        },
        {
          catalogNo: "TJCST2.502-2D",
          catalogNo3D: "TJCST2.502-3D",
          loopDia: "2.5",
          length: "2",
        },
        {
          catalogNo: "TJCST2.504-2D",
          catalogNo3D: "TJCST2.504-3D",
          loopDia: "2.5",
          length: "4",
        },
        {
          catalogNo: "TJCST2.506-2D",
          catalogNo3D: "TJCST2.506-3D",
          loopDia: "2.5",
          length: "6",
        },
        {
          catalogNo: "TJCST2.508-2D",
          catalogNo3D: "TJCST2.508-3D",
          loopDia: "2.5",
          length: "8",
        },
        {
          catalogNo: "TJCST0304-2D",
          catalogNo3D: "TJCST0304-3D",
          loopDia: "3",
          length: "4",
        },
        {
          catalogNo: "TJCST0306-2D",
          catalogNo3D: "TJCST0306-3D",
          loopDia: "3",
          length: "6",
        },
        {
          catalogNo: "TJCST0308-2D",
          catalogNo3D: "TJCST0308-3D",
          loopDia: "3",
          length: "8",
        },
        {
          catalogNo: "TJCST0310-2D",
          catalogNo3D: "TJCST0310-3D",
          loopDia: "3",
          length: "10",
        },
        {
          catalogNo: "TJCST0312-2D",
          catalogNo3D: "TJCST0312-3D",
          loopDia: "3",
          length: "12",
        },
        {
          catalogNo: "TJCST3.506-2D",
          catalogNo3D: "TJCST3.506-3D",
          loopDia: "3.5",
          length: "6",
        },
        {
          catalogNo: "TJCST3.508-2D",
          catalogNo3D: "TJCST3.508-3D",
          loopDia: "3.5",
          length: "8",
        },
        {
          catalogNo: "TJCST3.510-2D",
          catalogNo3D: "TJCST3.510-3D",
          loopDia: "3.5",
          length: "10",
        },
        {
          catalogNo: "TJCST3.512-2D",
          catalogNo3D: "TJCST3.512-3D",
          loopDia: "3.5",
          length: "12",
        },
        {
          catalogNo: "TJCST0404-2D",
          catalogNo3D: "TJCST0404-3D",
          loopDia: "4",
          length: "4",
        },
        {
          catalogNo: "TJCST0406-2D",
          catalogNo3D: "TJCST0406-3D",
          loopDia: "4",
          length: "6",
        },
        {
          catalogNo: "TJCST0408-2D",
          catalogNo3D: "TJCST0408-3D",
          loopDia: "4",
          length: "8",
        },
        {
          catalogNo: "TJCST0410-2D",
          catalogNo3D: "TJCST0410-3D",
          loopDia: "4",
          length: "10",
        },
      ],
      specs2: [
        // Group 2: 4.5mm - 20mm Loop Dia.
        {
          catalogNo: "TJCST4.506-2D",
          catalogNo3D: "TJCST4.506-3D",
          loopDia: "4.5",
          length: "6",
        },
        {
          catalogNo: "TJCST4.508-2D",
          catalogNo3D: "TJCST4.508-3D",
          loopDia: "4.5",
          length: "8",
        },
        {
          catalogNo: "TJCST4.510-2D",
          catalogNo3D: "TJCST4.510-3D",
          loopDia: "4.5",
          length: "10",
        },
        {
          catalogNo: "TJCST4.512-2D",
          catalogNo3D: "TJCST4.512-3D",
          loopDia: "4.5",
          length: "12",
        },
        {
          catalogNo: "TJCST4.515-2D",
          catalogNo3D: "TJCST4.515-3D",
          loopDia: "4.5",
          length: "15",
        },
        {
          catalogNo: "TJCST0509-2D",
          catalogNo3D: "TJCST0509-3D",
          loopDia: "5",
          length: "9",
        },
        {
          catalogNo: "TJCST0510-2D",
          catalogNo3D: "TJCST0510-3D",
          loopDia: "5",
          length: "10",
        },
        {
          catalogNo: "TJCST0515-2D",
          catalogNo3D: "TJCST0515-3D",
          loopDia: "5",
          length: "15",
        },
        {
          catalogNo: "TJCST0520-2D",
          catalogNo3D: "TJCST0520-3D",
          loopDia: "5",
          length: "20",
        },
        {
          catalogNo: "TJCST0610-2D",
          catalogNo3D: "TJCST0610-3D",
          loopDia: "6",
          length: "10",
        },
        {
          catalogNo: "TJCST0611-2D",
          catalogNo3D: "TJCST0611-3D",
          loopDia: "6",
          length: "11",
        },
        {
          catalogNo: "TJCST0615-2D",
          catalogNo3D: "TJCST0615-3D",
          loopDia: "6",
          length: "15",
        },
        {
          catalogNo: "TJCST0620-2D",
          catalogNo3D: "TJCST0620-3D",
          loopDia: "6",
          length: "20",
        },
        {
          catalogNo: "TJCST0715-2D",
          catalogNo3D: "TJCST0715-3D",
          loopDia: "7",
          length: "15",
        },
        {
          catalogNo: "TJCST0720-2D",
          catalogNo3D: "TJCST0720-3D",
          loopDia: "7",
          length: "20",
        },
        {
          catalogNo: "TJCST0730-2D",
          catalogNo3D: "TJCST0730-3D",
          loopDia: "7",
          length: "30",
        },
        {
          catalogNo: "TJCST0815-2D",
          catalogNo3D: "TJCST0815-3D",
          loopDia: "8",
          length: "15",
        },
        {
          catalogNo: "TJCST0820-2D",
          catalogNo3D: "TJCST0820-3D",
          loopDia: "8",
          length: "20",
        },
        {
          catalogNo: "TJCST0830-2D",
          catalogNo3D: "TJCST0830-3D",
          loopDia: "8",
          length: "30",
        },
        {
          catalogNo: "TJCST0920-2D",
          catalogNo3D: "TJCST0920-3D",
          loopDia: "9",
          length: "20",
        },
        {
          catalogNo: "TJCST0930-2D",
          catalogNo3D: "TJCST0930-3D",
          loopDia: "9",
          length: "30",
        },
        {
          catalogNo: "TJCST1020-2D",
          catalogNo3D: "TJCST1020-3D",
          loopDia: "10",
          length: "20",
        },
        {
          catalogNo: "TJCST1030-2D",
          catalogNo3D: "TJCST1030-3D",
          loopDia: "10",
          length: "30",
        },
        {
          catalogNo: "TJCST1130-2D",
          catalogNo3D: "TJCST1130-3D",
          loopDia: "11",
          length: "30",
        },
        {
          catalogNo: "TJCST1230-2D",
          catalogNo3D: "TJCST1230-3D",
          loopDia: "12",
          length: "30",
        },
        {
          catalogNo: "TJCST1330-2D",
          catalogNo3D: "TJCST1330-3D",
          loopDia: "13",
          length: "30",
        },
        {
          catalogNo: "TJCST1430-2D",
          catalogNo3D: "TJCST1430-3D",
          loopDia: "14",
          length: "30",
        },
        {
          catalogNo: "TJCST1530-2D",
          catalogNo3D: "TJCST1530-3D",
          loopDia: "15",
          length: "30",
        },
        {
          catalogNo: "TJCST1630-2D",
          catalogNo3D: "TJCST1630-3D",
          loopDia: "16",
          length: "30",
        },
        {
          catalogNo: "TJCST1830-2D",
          catalogNo3D: "TJCST1830-3D",
          loopDia: "18",
          length: "30",
        },
        {
          catalogNo: "TJCST2030-2D",
          catalogNo3D: "TJCST2030-3D",
          loopDia: "20",
          length: "30",
        },
      ],
      features: [
        {
          title: "Complete Models and Precise Positioning",
          description:
            'Spiral and complex spring coils, from basket formation, filling to finishing, all specifications and models are available. It can match all 0.0165"-0.021" inner diameter micro-catheters on the market. The dual-Marker design can accurately locate the delivery rod and the position of the release point.',
          image: perdenser1,
        },
        {
          title: "Rigid and Flexible Conveying System",
          description:
            "The delivery rod has a segmented design with different hardness, the proximal end is more rigid and the distal end is softer. The lengthened soft section design and shorter release point structure ensure the push rod to pass through tortuous blood vessels. The strengthened proximal push rod design provides nearly 100% push force, making the surgeon handy.",
          image: perdenser2,
        },
        {
          title: "Tough Anti-Unspinning Power",
          description:
            "The polymer anti-untwisting system provides an anti-untwisting force of not less than 0.4N. It provides a strong guarantee for the secondary adjustment in the operation.",
          image: perdenser3,
        },
        {
          title: "Soft Lead-in Ring",
          description:
            "The implantation section is made of platinum-tungsten alloy, with a smooth polymer ball cap which is flexible.",
          image: perdenser4,
        },
        {
          title: "Uniform and Dense Filling",
          description:
            "The optimized O open loop design can fit an aneurysm of any shape at random turning points. The spring coils spread out evenly in 360 degrees to construct a stable basket frame. Fully capture the space for centripetal filling layer by layer and finally achieve the ideal dense embolism.",
          image: perdenser5,
        },
        {
          title: "Safe and Reliable Instant Release System",
          description:
            "The release point adopts advanced polymer wire instant fuse technology to achieve second release. The shape of the freed tail is smooth and soft, and there is no additional chemical residue. The operation process is simple, safe, stable, and controllable!",
          image: perdenser6,
        },
      ],
    },
    perfiller: {
      title: "Perfiller®",
      subtitle: " Expansible Embolic Coil System",
      description: "Expansible Embolic Coil System",
      specs: [
        {
          softness: "Extra Soft",
          specs3D: [
            {
              catalogNo: "TJCHYF0102",
              loopDia: "1.5",
              length: "2",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1.502",
              loopDia: "2",
              length: "2",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1.503",
              loopDia: "2",
              length: "2",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0202",
              loopDia: "2.5",
              length: "2",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0204",
              loopDia: "2.5",
              length: "4",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0206",
              loopDia: "2.5",
              length: "6",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF2.502",
              loopDia: "3",
              length: "4",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF2.504",
              loopDia: "3",
              length: "6",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF2.506",
              loopDia: "3",
              length: "10",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0304",
              loopDia: "3",
              length: "5",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0306",
              loopDia: "4",
              length: "10",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0308",
              loopDia: "4",
              length: "5",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0310",
              loopDia: "4",
              length: "10",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0405",
              loopDia: "4",
              length: "5",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF040B",
              loopDia: "4",
              length: "10",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0410",
              loopDia: "4",
              length: "10",
              coilStructure: "Complex",
            },
          ],
          specs2D: [
            {
              catalogNo: "TJCHYL0102",
              loopDia: "1",
              length: "2",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL1.501",
              loopDia: "1.5",
              length: "1",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL1.502",
              loopDia: "1.5",
              length: "2",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL1.504",
              loopDia: "1.5",
              length: "4",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0201",
              loopDia: "2",
              length: "1",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0202",
              loopDia: "2",
              length: "2",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0203",
              loopDia: "2",
              length: "3",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0204",
              loopDia: "2",
              length: "4",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0206",
              loopDia: "2",
              length: "6",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0208",
              loopDia: "2",
              length: "8",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL2.502",
              loopDia: "2.5",
              length: "2",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL2.504",
              loopDia: "2.5",
              length: "4",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL2.506",
              loopDia: "2.5",
              length: "6",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0302",
              loopDia: "3",
              length: "2",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0303",
              loopDia: "3",
              length: "3",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0304",
              loopDia: "3",
              length: "4",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0306",
              loopDia: "3",
              length: "6",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0308",
              loopDia: "3",
              length: "8",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0310",
              loopDia: "3",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0312",
              loopDia: "3",
              length: "12",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0404",
              loopDia: "4",
              length: "4",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0406",
              loopDia: "4",
              length: "6",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0408",
              loopDia: "4",
              length: "8",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0410",
              loopDia: "4",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0415",
              loopDia: "4",
              length: "15",
              coilStructure: "Helical",
            },
          ],
        },
        {
          softness: "Soft",
          specs3D: [
            {
              catalogNo: "TJCHYF0510",
              loopDia: "5",
              length: "10",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0515",
              loopDia: "5",
              length: "15",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0612",
              loopDia: "6",
              length: "12",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0620",
              loopDia: "6",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0715",
              loopDia: "7",
              length: "15",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0720",
              loopDia: "7",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0728",
              loopDia: "7",
              length: "28",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0817",
              loopDia: "8",
              length: "17",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0830",
              loopDia: "9",
              length: "30",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0920",
              loopDia: "9",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0930",
              loopDia: "9",
              length: "30",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1020",
              loopDia: "10",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1030",
              loopDia: "10",
              length: "30",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1120",
              loopDia: "11",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1130",
              loopDia: "11",
              length: "30",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYFI 140",
              loopDia: "11",
              length: "40",
              coilStructure: "Complex",
            },
          ],
          specs2D: [
            {
              catalogNo: "TJCH0404",
              loopDia: "4",
              length: "4",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0406",
              loopDia: "4",
              length: "6",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0408",
              loopDia: "4",
              length: "8",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0410",
              loopDia: "4",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0510",
              loopDia: "5",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0515",
              loopDia: "5",
              length: "15",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0610",
              loopDia: "6",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0615",
              loopDia: "6",
              length: "15",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0620",
              loopDia: "6",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0625",
              loopDia: "6",
              length: "25",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0710",
              loopDia: "7",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0720",
              loopDia: "7",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0730",
              loopDia: "7",
              length: "30",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0810",
              loopDia: "8",
              length: "10",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0820",
              loopDia: "8",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0830",
              loopDia: "8",
              length: "30",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0930",
              loopDia: "9",
              length: "30",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL0935",
              loopDia: "9",
              length: "35",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYL1030",
              loopDia: "10",
              length: "30",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCHYLI 040",
              loopDia: "10",
              length: "40",
              coilStructure: "Helical",
            },
          ],
        },
        {
          softness: "Standard",
          specs3D: [
            {
              catalogNo: "TJCHYF0720",
              loopDia: "7",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0820",
              loopDia: "8",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF0920",
              loopDia: "9",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1020",
              loopDia: "10",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1120",
              loopDia: "11",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1220",
              loopDia: "12",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1320",
              loopDia: "13",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1420",
              loopDia: "14",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1520",
              loopDia: "15",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1620",
              loopDia: "16",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF1820",
              loopDia: "18",
              length: "20",
              coilStructure: "Complex",
            },
            {
              catalogNo: "TJCHYF2020",
              loopDia: "20",
              length: "20",
              coilStructure: "Complex",
            },
          ],
          specs2D: [
            {
              catalogNo: "TJCH0720",
              loopDia: "7",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0820",
              loopDia: "8",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH0920",
              loopDia: "9",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1020",
              loopDia: "10",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1120",
              loopDia: "11",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1220",
              loopDia: "12",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1320",
              loopDia: "13",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1420",
              loopDia: "14",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1520",
              loopDia: "15",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1620",
              loopDia: "16",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH1820",
              loopDia: "18",
              length: "20",
              coilStructure: "Helical",
            },
            {
              catalogNo: "TJCH2020",
              loopDia: "20",
              length: "20",
              coilStructure: "Helical",
            },
          ],
        },
      ],
      features: [
        {
          title: "Superior Crossing Ability",
          description:
            "The polymer thread swells when exposed to water, which effectively increases the embolization density, immediately achieves a compact embolization effect, and effectively reduces the long-term recurrence rate.",
          image: perfiller1,
        },
        {
          title: "Precise Sizing",
          description:
            "The expansion of the polymer wire can effectively increase the stability of the ring body and avoid the compression of the packed spring coil under the impact of blood flow, thereby ensuring long-term effective sealing of the tumor neck, eliminating 'dog ear signs', and effectively reducing the recurrence rate.",
          image: perfiller2,
        },
        {
          title: "Strong Pushability",
          description:
            "The metal occupancy rate of the expansion ring of the same length is lower, the ring body is softer, and the effectiveness and safety during use are improved. The smallest ring diameter is 1 mm and a variety of half-size rings provide more options for small or tiny aneurysms and closing. The new push system makes the transmission of the push rod mechanics more effective, and the push process is easier and smoother.",
          image: perfiller3,
        },
        {
          title: "Safe and Reliable Instant Release System",
          description:
            "The release point adopts advanced polymer wire instant fuse technology to achieve second release. The shape of the freed tail is smooth and soft, and there is no additional chemical residue. The operation process is simple, safe, stable, and controllable!",
          image: perdenser6,
        },
      ],
    },
    "angio-clean": {
      title: "Angio - Clean",
      subtitle: "Angiographic Cleaning System",
      description:
        "Angiographic Diagnostic Catheter",
      image: angioClean1,
      brochure: angiocleanPDF,
      specs: [],
      features: [
        {
          title: "Hydrophilic Tip & Smooth Navigation",
          description:
            "Durable hydrophilic coating combined with a low-profile atraumatic tip improves trackability and reduces vessel wall friction in tortuous anatomy.",
          image: angioVertebral,
          imageHeight: 420,
         // imageContain: true,
          compact: true,
        },
        {
          title: "Anatomic Shapes For Targeting",
          description:
            "Preformed curves (Cobra, Simmons, Headhunter, J‑curves) provide rapid selective engagement of target vessels, reducing procedure time.",
          image: angioCobra,
          imageHeight: 420,
          // imageContain: true,
          compact: true,
        },
        {
          title: "Radiopaque Markers & Easy Flush",
          description:
            "Integrated radiopaque markers for confident positioning and a flushable design that simplifies blood clearance and device maintenance intra-procedure.",
          image: angioHeadhunter,
          imageHeight: 420,
         // imageContain: true,
          compact: true,
        },
        {
          title: "Universal Compatibility",
          description:
            "Low-profile shafts compatible with common guidewires and sheaths for seamless integration into routine angiographic workflows.",
          image: angioSim,
          imageHeight: 420,
          //imageContain: true,
          compact: true,
        },
      ],
    },
    hydra: {
      title: "Hydra G.W",
      subtitle: "Hydrophilic Catheter Family",
      description:
        "Hydra 0.035\" Hydrophilic G.W",
      image: hydra1,
      brochure: hydraPDF,
      specs: [],
      features: [],
    },
    "neuro-soft": {
      title: "NeuroSoft G.W",
      subtitle: "Soft Neurovascular Coils",
      description:
        "Neuro-Soft 0.014\" Hydrophilic G.W",
      image: neuroSoft1,
      brochure: neurosoftPDF,
      specs: [
        {
          productName:
            '0.014" GUIDE WIRE STRAIGHT STANDARD HYDROPHILIC COATED (35 cm distal coil)',
          tipFeature: '0.014" DISTAL DIAMETER',
          length: "200 cm",
          reference: "GW-014H-200SSH35",
        },
        {
          productName:
            '0.014" GUIDE WIRE STRAIGHT STANDARD HYDROPHILIC COATED (35 cm distal coil)',
          tipFeature: '0.014" DISTAL DIAMETER',
          length: "300 cm",
          reference: "GW-014H-300SSH35",
        },
        {
          productName:
            '0.014" GUIDE WIRE STRAIGHT SOFT HYDROPHILIC COATED (35 cm distal coil)',
          tipFeature: '0.012"-0.014" TAPERED DISTAL',
          length: "200 cm",
          reference: "GW-014H-200SFH35",
        },
        {
          productName:
            '0.014" GUIDE WIRE STRAIGHT SOFT HYDROPHILIC COATED (35 cm distal coil)',
          tipFeature: '0.012"-0.014" TAPERED DISTAL',
          length: "300 cm",
          reference: "GW-014H-300SFH35",
        },
      ],
      features: [
        {
          title: "Neuro-Soft Hydrophilic Guidewire",
          description:
            "Hydrophilic coating on a 0.014\" platform delivers smooth tracking, balanced support, and tactile feedback for delicate neurovascular navigation.",
          image: neuroSoft1,
          fullWidth: true,
        },
        {
          title: "Atraumatic, Shapeable Tip",
          description:
            "Shapeable distal tip with progressive softness supports precise steering through tortuous anatomy while minimizing vessel trauma.",
          image: neuroSoft2,
          imageSmall: true,
          imageHorizontal: true,
          centered: true,
        },
      ],
    },
    "neuro-cath-support": {
      title: "NeuroCath Support",
      subtitle: "Catheter Support Sizes",
      description:
        "Neurovascular Distal Access Catheter",
      image: neuroCathSupport1,
      brochure: neurocathSupportPDF,
      specs: [],
      features: [
        {
          title: "PERFECT ASPIRATION",
          description:
            "Optimized lumen and geometry enable efficient aspiration and reliable thrombus removal during procedures.",
          image: neuroCathSupport1,
          alignBottom: true,
          imageCentered: true,
        },
        {
          title: "PERFECT HYDROPHILIC COATING",
          description:
            "Durable hydrophilic coating reduces friction for smooth navigation and atraumatic vessel interaction.",
          image: neuroCathSupport2,
        },
        {
          title: "DISTAL 25 CM SUPER FLEXIBLE",
          description:
            "A 25 cm ultra-flexible distal segment conforms to tortuous anatomy while preserving proximal support.",
          image: neuroCathSupport3,
        },
        {
          title: "HYBRIT CATHETER DESIGN (BRAID + COIL)",
          description:
            "Hybrid braid + coil construction balances pushability and flexibility for controlled device delivery.",
          fullWidth: true,
        },
      ],
    },
    microcatheter: {
      title: "Microcatheters",
      subtitle: "NeuroCath Platform",
      description:
        "Select the NeuroCath size to view its specifications. Variants include 17\", 21\", and 27\" configurations for tailored device delivery.",
      image: mic1,
      brochure: microcathetersPDF,
      specs: [],
      features: [],
    },
    neurosheath: {
      title: "NeuroSheath",
      subtitle: "Introducer Sheath System",
      description:
        "NeuroSheath Guiding Catheter Dilator Kit",
      image: neuroCathSupport2,
      brochure: neurosheathPDF,
      specs: [
        {
          productName: "GUIDING CATHETER STRAIGHT TIP - 45 CM DILATOR KIT",
          f5: "GC5F-STRKlT45",
          f6: "GC6F-STRKIT45",
          f7: "GC7F-STRKIT45",
          f8: "GC8F-STRKlT45",
        },
        {
          productName: "GUIDING CATHETER STRAIGHT TIP - 55 CM DILATOR",
          f5: "GC5F-STRKlT55",
          f6: "GC6F-STRKIT55",
          f7: "GC7F-STRKIT55",
          f8: "GC8F-STRKlT55",
        },
        {
          productName: "GUIDING CATHETER STRAIGHT TIP - 65 CM DILATOR",
          f5: "GC5F-STRKlT65",
          f6: "GC6F-STRKIT65",
          f7: "GC7F-STRKIT65",
          f8: "GC8F-STRKlT65",
        },
        {
          productName: "GUIDING CATHETER STRAIGHT TIP - 80 CM DILATOR KIT",
          f5: "GC5F-STRKlT80",
          f6: "GC6F-STRKIT80",
          f7: "GC7F-STRKIT80",
          f8: "GC8F-STRKlT80",
        },
        {
          productName: "GUIDING CATHETER STRAIGHT TIP - 90 CM DILATOR",
          f5: "GC5F-STRKlT90",
          f6: "GC6F-STRKIT90",
          f7: "GC7F-STRKIT90",
          f8: "GC8F-STRKlT90",
        },
        {
          productName: "GUIDING CATHETER STRAIGHT - 80 CM DILATOR KIT Y CONNEKTOR",
          f5: "GC5F-STRKlT80SY",
          f6: "GC6F-STRKIT80SY",
          f7: "GC7F-STRKIT80SY",
          f8: "GC8F-STRKlT80SY",
        },
        {
          productName: "GUIDING CATHETER STRAIGHT - 90 CM DILATOR KIT Y CONNEKTOR",
          f5: "GC5F-STRKlT90SY",
          f6: "GC6F-STRKIT90SY",
          f7: "GC7F-STRKIT90SY",
          f8: "GC8F-STRKlT90SY",
        },
        {
          productName: "GUIDING CATHETER MULTIPURPOSE TIP - 45 CM DILATOR KIT",
          f5: "GC5F-MPKlT45",
          f6: "GC6F-MPKlT45",
          f7: "GC7F-MPKIT45",
          f8: "GC8F-MPKlT45",
        },
        {
          productName: "GUIDING CATHETER MULTIPURPOSE TIP - 55 CM DILATOR KIT",
          f5: "GC5F-MPKlT55",
          f6: "GC6F-MPKlT55",
          f7: "GC7F-MPKIT55",
          f8: "GC8F-MPKlT55",
        },
        {
          productName: "GUIDING CATHETER MULTIPURPOSE TIP - 65 CM DILATOR KIT",
          f5: "GC5F-MPKlT65",
          f6: "GC6F-MPKlT65",
          f7: "GC7F-MPKlT65",
          f8: "GC8F-MPKlT65",
        },
        {
          productName: "GUIDING CATHETER MULTIPURPOSE TIP - 90 CM DILATOR KIT",
          f5: "GC5F-MPKlT90",
          f6: "GC6F-MPKlT90",
          f7: "GC7F-MPKlT90",
          f8: "GC8F-MPKlT90",
        },
        {
          productName: "GUIDING CATHETER MULTIPURPOSE TIP - 80 CM DILATOR Y CONNEKTOR",
          f5: "GC5F-MPKlT80SY",
          f6: "GC6F-MPKIT80SY",
          f7: "GC7F-MPKIT80SY",
          f8: "GC8F-MPKlT80SY",
        },
        {
          productName: "GUIDING CATHETER MULTIPURPOSE TIP - 90 CM DILATOR KIT Y CONNEKTOR",
          f5: "GC5F-MPKlT90SY",
          f6: "GC6F-MPKIT90SY",
          f7: "GC7F-MPKIT90SY",
          f8: "GC8F-MPKlT90SY",
        },
      ],
      features: [
        {
          title: "NeuroSheath",
          description: "",
          image: neurosheathHero,
          fullWidth: true,
          imageHeight: 300,
          compact: true
        },
        {
          title: "Stainless Steel Coil",
          description:
            "Stainless steel/SUS coil makes catheter body soft and flexible.",
          image: neurosheathStainless,
          imageSmall: true,
        },
        {
          title: "Smooth Dilator Transition",
          description:
            "Smooth transition between Dilator and Sheath for consistent delivery.",
          image: neurosheathDilator,
          imageSmall: true,
        },
        {
          title: "Pt/Ir Marker Radiopacity",
          description:
            "Pt/Ir marker provides good radiopacity for confident positioning.",
          image: neurosheathPt,
          imageSmall: true,
        },
        {
          title: "Easy Valve Adapter",
          description:
            "Easy-to-attach valve adapter; quickly attaches with Y connector, removable and provides hemostasis.",
          image: neurosheathY,
          imageSmall: true,
        },
      ],
    },
    "neurocath-plus": {
      title: "NeuroCath Plus",
      subtitle: "Enhanced Catheter Family",
      description:
        "Aspiration Catheter Distal 30 cm Super Flexible Hybrit Catheter Design (BRAID + COIL)",
      image: neurocathPlus1,
      brochure: neurocathPlusPDF,
      specs: [
        { size: "5F", innerDiameter: '0.058\"', length: "125 CM", shape: "STRAIGHT" },
        { size: "6F", innerDiameter: '0.071\"', length: "125 CM", shape: "STRAIGHT" },
        { size: "8F", innerDiameter: '0.090\"', length: "125 CM", shape: "STRAIGHT" },
      ],
      features: [
        {
          title: "Hydrophilic Coating",
          description:
            "Durable hydrophilic coating for low friction and smooth navigation — improves trackability and reduces push force.",
          image: neurocathPlus1,
        },
        {
          title: "Optimized Aspiration",
          description:
            "Large lumen and smooth inner surface enable efficient aspiration and flushing during procedures, helping maintain clear visualization.",
          image: neurocathPlus2,
        },
        {
          title: "Track Through Tortuous Bends",
          description:
            "Track through tortuous distal bends without kinking, maintaining lumen integrity in challenging anatomy.",
        },
        {
          title: "Hybrid Braid And Coil",
          description:
            "Hybrid braid and coil reinforcement provides superior push response for confident device delivery.",
        },
        {
          title: "Braid Overlay Torque Control",
          description:
            "Braid overlay delivers excellent torque response to bypass difficult bifurcations with precision.",
        },
        {
          title: "Flexible Distal Segment",
          description:
            "30 cm super-flexible distal section conforms to tortuous anatomy while preserving proximal support for device delivery.",
          fullWidth: true,
        },
      ],
    },
  };

  // Explicit nav order: put `neurocath-plus` right after `perfiller`
  const productOrder = [
    "proender",
    "perrdenser",
    "perfiller",
    "neurocath-plus",
    "neuro-cath-support",
    "microcatheter",
    "neurosheath",
    "neuro-soft",
    "hydra",
    "angio-clean",
  ];

  const microcatheterVariants = [
    { key: "neurocath-17", label: "NeuroCath 17\"" },
    { key: "neurocath-21", label: "NeuroCath 21\"" },
    { key: "neurocath-27", label: "NeuroCath 27\"" },
  ];

  const microcatheterSpecs = {
    "neurocath-17": [
      {
        itemNumber: "MC17F22F150",
        outerDiameter: "2.2>1.7",
        innerDiameter: "0.017",
        workingLength: "150 cm",
      },
      {
        itemNumber: "MC18F22F150",
        outerDiameter: "2.2>1.8",
        innerDiameter: "0.017",
        workingLength: "150 cm",
      },
    ],
    "neurocath-21": [
      {
        itemNumber: "MC21F27F150",
        outerDiameter: "2.7>2.1",
        innerDiameter: "0.021",
        workingLength: "150 cm",
      },
      {
        itemNumber: "MC21F27F150",
        outerDiameter: "2.7>2.4",
        innerDiameter: "0.021",
        workingLength: "150 cm",
      },
    ],
    "neurocath-27": [
      {
        itemNumber: "MC26F28F150",
        outerDiameter: "2.8>2.6",
        innerDiameter: "0.027",
        workingLength: "150 cm",
      },
      {
        itemNumber: "MC31F150",
        outerDiameter: "3.1>2.6",
        innerDiameter: "0.027",
        workingLength: "150 cm",
      },
      {
        itemNumber: "MC27F29F150",
        outerDiameter: "2.9>2.7",
        innerDiameter: "0.027",
        workingLength: "150 cm",
      },
    ],
  };

  // Helper: convert feature titles to Title Case (First letter of each word uppercase)
  const titleCase = (str = "") =>
    String(str)
      .toLowerCase()
      .replace(/\b\w/g, (c) => c.toUpperCase());

  const handleDownload = () => {
    if (selectedProduct === "perrdenser") {
      // Prepare table data for Perdenser
      const tableData1 = [
        // Group 1 header row
        [
          "Catalogue No. Helical (2D)",
          "Catalogue No. Complex (3D)",
          "Loop Dia. (mm)",
          "Length (cm)",
        ],
        // Group 1 data
        ...products[selectedProduct].specs.map((spec) => [
          spec.catalogNo,
          spec.catalogNo3D,
          spec.loopDia,
          spec.length,
        ]),
      ];

      const tableData2 = [
        // Group 2 header row
        [
          "Catalogue No. Helical (2D)",
          "Catalogue No. Complex (3D)",
          "Loop Dia. (mm)",
          "Length (cm)",
        ],
        // Group 2 data
        ...products[selectedProduct].specs2.map((spec) => [
          spec.catalogNo,
          spec.catalogNo3D,
          spec.loopDia,
          spec.length,
        ]),
      ];

      // Create Excel workbook
      const wb = XLSX.utils.book_new();

      // Create separate sheets for each group
      const ws1 = XLSX.utils.aoa_to_sheet(tableData1);
      const ws2 = XLSX.utils.aoa_to_sheet(tableData2);

      // Add sheets to workbook
      XLSX.utils.book_append_sheet(wb, ws1, "Group 1 (1.5-4mm)");
      XLSX.utils.book_append_sheet(wb, ws2, "Group 2 (4.5-20mm)");

      // Download Excel file
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(data, `${products[selectedProduct].title}_Specifications.xlsx`);
    } else {
      // Existing download function for Proender
      const tableData = [
        // Header row
        [
          "Catalogue No.",
          "Filter Diameter (mm)",
          "Guidewire Length (cm)",
          "Guidewire Compatibility",
          "Delivery Sheath O.D.",
          "Retrieval Sheath O.D.",
          "Guiding Catheter Compatibility (min.)",
        ],
        // Product data
        ...products[selectedProduct].specs.map((spec) => [
          spec.catalogNo,
          spec.diameter,
          spec.length,
          spec.compatibility,
          spec.sheath,
          spec.retrievalSheath,
          spec.guidingCatheter,
        ]),
      ];

      // Create Excel workbook
      const ws = XLSX.utils.aoa_to_sheet(tableData);
      const wb = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(wb, ws, "Specifications");

      // Download Excel file
      const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
      const data = new Blob([excelBuffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      saveAs(data, `${products[selectedProduct].title}_Specifications.xlsx`);
    }
  };

  const handleDownloadPDF = (type) => {
    let pdfUrl;
    switch (selectedProduct) {
      case "proender":
        pdfUrl = type === "brochure" ? proenderPDF : proenderIFUPDF;
        break;
      case "perrdenser":
        pdfUrl = type === "brochure" ? perdenserPDF : perdenserIFUPDF;
        break;
      case "perfiller":
        pdfUrl = type === "brochure" ? perfillerPDF : perfillerIFUPDF;
        break;
      case "neurocath-plus":
        pdfUrl = type === "brochure" ? neurocathPlusPDF : neurocathPlusIFUPDF;
        break;
      case "neuro-cath-support":
        pdfUrl = type === "brochure" ? neurocathSupportPDF : neurocathSupportIFUPDF;
        break;
      case "microcatheter":
        pdfUrl = type === "brochure" ? microcathetersPDF : microcathetersIFUPDF;
        break;
      case "neurosheath":
        pdfUrl = type === "brochure" ? neurosheathPDF : neurosheathIFUPDF;
        break;
      case "neuro-soft":
        pdfUrl = type === "brochure" ? neurosoftPDF : neurosoftIFUPDF;
        break;
      case "hydra":
        pdfUrl = type === "brochure" ? hydraPDF : hydraIFUPDF;
        break;
      case "angio-clean":
        pdfUrl = type === "brochure" ? angiocleanPDF : angiocleanIFUPDF;
        break;
      default:
        return;
    }

    // Check if PDF exists
    if (!pdfUrl) {
      return;
    }

    // Download PDF
    fetch(pdfUrl)
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `${products[selectedProduct].title}_${
          type === "brochure" ? "Product_Information" : "IFU"
        }.pdf`;
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
      });
  };

  return (
    <div className="page-container">
      <motion.section
        className="product-hero"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1 }}
      >
        <motion.h1
          initial={{ y: -50, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
        >
          Our Products
        </motion.h1>
        <motion.p
          className="product-subtitle"
          initial={{ y: -30, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          transition={{ delay: 0.4, duration: 0.8 }}
        >
          Innovative Endovascular Treatment Solutions
        </motion.p>
      </motion.section>

      <section className="product-content">
        <div className="products-nav">
          {productOrder
            .filter((k) => products[k])
            .map((productKey) => (
              <button
                key={productKey}
                className={`product-nav-button ${
                  selectedProduct === productKey ? "active" : ""
                }`}
                onClick={() => setSelectedProduct(productKey)}
              >
                {products[productKey].title}
              </button>
            ))}
        </div>

        <div className="product-description">
          <p>{products[selectedProduct].description}</p>
        </div>

        {selectedProduct !== "microcatheter" && (
          <div className="product-tabs">
            <button
              className={`tab-button ${
                activeTab === "specifications" ? "active" : ""
              }`}
              onClick={() => setActiveTab("specifications")}
            >
              Product Specifications
            </button>
            <button
              className={`tab-button ${activeTab === "features" ? "active" : ""}`}
              onClick={() => setActiveTab("features")}
            >
              Features
            </button>
          </div>
        )}

        <div className="tab-content">
          {selectedProduct === "microcatheter" ? (
            <motion.div
              key={selectedProduct + "-micro"}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="specifications-table"
            >
              <div className="coil-type-selector" style={{ marginBottom: "0.75rem" }}>
                {microcatheterVariants.map((variant) => (
                  <button
                    key={variant.key}
                    className={`coil-type-button ${microVariant === variant.key ? "active" : ""}`}
                    onClick={() => setMicroVariant(variant.key)}
                  >
                    {variant.label}
                  </button>
                ))}
              </div>

              <div className="product-tabs" style={{ marginTop: "0.25rem" }}>
                <button
                  className={`tab-button ${microActiveTab === "specifications" ? "active" : ""}`}
                  onClick={() => setMicroActiveTab("specifications")}
                >
                  Product Specifications
                </button>
                <button
                  className={`tab-button ${microActiveTab === "features" ? "active" : ""}`}
                  onClick={() => setMicroActiveTab("features")}
                >
                  Features
                </button>
              </div>

              {microActiveTab === "specifications" ? (
                <>
                  <div className="table-header">
                    <motion.button
                      className="download-button"
                      onClick={() => handleDownloadPDF("brochure")}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      Download Brochure
                    </motion.button>
                    <motion.button
                      className="download-button"
                      onClick={() => handleDownloadPDF("ifu")}
                      whileHover={{ scale: 1.05 }}
                      whileTap={{ scale: 0.95 }}
                    >
                      Download IFU
                    </motion.button>
                  </div>
                  {microcatheterSpecs[microVariant] && microcatheterSpecs[microVariant].length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Item Number</th>
                          <th>Outer Diameter (O.D.)</th>
                          <th>Inner Diameter (I.N.)</th>
                          <th>Working Length</th>
                        </tr>
                      </thead>
                      <tbody>
                        {microcatheterSpecs[microVariant].map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.itemNumber}</td>
                            <td>{row.outerDiameter}</td>
                            <td>{row.innerDiameter}</td>
                            <td>{row.workingLength}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ padding: "1rem", color: "#666" }}>
                      Specifications for {microcatheterVariants.find((v) => v.key === microVariant)?.label || "this variant"} will be added soon.
                    </div>
                  )}
                </>
              ) : (
                <div className="features-grid centered">
                  {microVariant === "neurocath-17" && (
                    <div className="feature-card">
                      <div className="feature-image contain tall">
                        <img src={mic1} alt="NeuroCath 17" />
                      </div>
                      <h3>NeuroCath 17" Features</h3>
                      <p>
                        NeuroCath 17" catheter is engineered to establish a steady tip foundation, making it ideal for coil deployment. Its structural design combines a rigid proximal shaft with a highly flexible distal shaft, ensuring excellent navigability through tortuous anatomy and facilitating seamless coil delivery.
                      </p>
                    </div>
                  )}
                  {microVariant === "neurocath-21" && (
                    <div className="feature-card">
                      <div className="feature-image contain tall">
                        <img src={mic2} alt="NeuroCath 21" />
                      </div>
                      <h3>NeuroCath 21" Features</h3>
                      <p>
                        NeuroCath 21" microcatheter features an extended 150 cm length to enhance procedural access. This design facilitates triaxial configurations utilizing a distal access catheter and ensures effective navigation through tortuous vascular anatomy.
                      </p>
                    </div>
                  )}
                  {microVariant === "neurocath-27" && (
                    <div className="feature-card">
                      <div className="feature-image contain tall">
                        <img src={mic3} alt="NeuroCath 27" />
                      </div>
                      <h3>NeuroCath 27" Features</h3>
                      <p>
                        The internal structure of the catheter is engineered to prevent flattening, creating a durable pathway that allows advanced devices to glide with minimal friction.
                      </p>
                      <p>
                        Additionally, the rounded distal tip improves tracking over the wire and assists in recapturing devices. The NeuroCath 27"’s optimized distal shaft offers a perfect balance, being flexible enough for navigation yet stable when needed.
                      </p>
                    </div>
                  )}
                </div>
              )}
            </motion.div>
          ) : activeTab === "specifications" && (
            <motion.div
              key={selectedProduct + "-specs"}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="specifications-table"
            >
              <div className="table-header">
                <motion.button
                  className="download-button"
                  onClick={() => handleDownloadPDF("brochure")}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Download Brochure
                </motion.button>
                <motion.button
                  className="download-button"
                  onClick={() => handleDownloadPDF("ifu")}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                >
                  Download IFU
                </motion.button>
              </div>
              {selectedProduct === "perrdenser" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Catalogue No. Helical (2D)</th>
                        <th>Catalogue No. Complex (3D)</th>
                        <th>Loop Dia. (mm)</th>
                        <th>Length (cm)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {getCurrentItems([
                        ...products[selectedProduct].specs,
                        ...products[selectedProduct].specs2,
                      ]).map((spec, index) => (
                        <motion.tr
                          key={spec.catalogNo}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: index * 0.05 }}
                        >
                          <td>{spec.catalogNo}</td>
                          <td>{spec.catalogNo3D}</td>
                          <td>{spec.loopDia}</td>
                          <td>{spec.length}</td>
                        </motion.tr>
                      ))}
                    </tbody>
                  </table>

                  {/* Sayfalama kontrolleri */}
                  <div className="pagination-controls">
                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(prev - 1, 1))
                      }
                      disabled={currentPage === 1}
                      className="pagination-button"
                    >
                      Previous
                    </button>
                    <span className="page-info">
                      Page {currentPage} /{" "}
                      {totalPages([
                        ...products[selectedProduct].specs,
                        ...products[selectedProduct].specs2,
                      ])}
                    </span>
                    <button
                      onClick={() =>
                        setCurrentPage((prev) =>
                          Math.min(
                            prev + 1,
                            totalPages([
                              ...products[selectedProduct].specs,
                              ...products[selectedProduct].specs2,
                            ])
                          )
                        )
                      }
                      disabled={
                        currentPage ===
                        totalPages([
                          ...products[selectedProduct].specs,
                          ...products[selectedProduct].specs2,
                        ])
                      }
                      className="pagination-button"
                    >
                      Next
                    </button>
                  </div>

                  <p
                    style={{
                      marginTop: "1rem",
                      fontSize: "0.9rem",
                      color: "#666",
                    }}
                  >
                    * Minimal microcatheter inner diameter compatibility:
                    0.0165"
                  </p>
                </>
              ) : selectedProduct === "proender" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Catalogue No.</th>
                        <th>Filter Diameter (mm)</th>
                        <th>Guidewire Length (cm)</th>
                        <th>Guidewire Compatibility</th>
                        <th>Delivery Sheath O.D.</th>
                        <th>Retrieval Sheath O.D.</th>
                        <th>Guiding Catheter Compatibility (min.)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products[selectedProduct].specs.map((spec, index) => (
                        <motion.tr
                          key={spec.catalogNo}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: index * 0.1 }}
                        >
                          <td>{spec.catalogNo}</td>
                          <td>{spec.diameter}</td>
                          <td>{spec.length}</td>
                          <td>{spec.compatibility}</td>
                          <td>{spec.sheath}</td>
                          <td>{spec.retrievalSheath}</td>
                          <td>{spec.guidingCatheter}</td>
                        </motion.tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ) : selectedProduct === "perfiller" ? (
                <>
                  <div className="coil-type-selector">
                    <button
                      className={`coil-type-button ${
                        coilType === "3D" ? "active" : ""
                      }`}
                      onClick={() => setCoilType("3D")}
                    >
                      3D Products
                    </button>
                    <button
                      className={`coil-type-button ${
                        coilType === "2D" ? "active" : ""
                      }`}
                      onClick={() => setCoilType("2D")}
                    >
                      2D Products
                    </button>
                  </div>
                  <div className="specifications-table">
                    <table className="coil-structure-table">
                      <thead>
                        <tr>
                          <th>Softness</th>
                          <th>Specification</th>
                          <th>Loop Dia. (mm)</th>
                          <th>Length (cm)</th>
                          <th>Coil Structure</th>
                        </tr>
                      </thead>
                      <tbody>
                        {products[selectedProduct].specs.map((specGroup) => {
                          // Eğer 2D seçiliyse ve softness "Standard" ise, bu grubu atla
                          if (
                            coilType === "2D" &&
                            specGroup.softness === "Standard"
                          ) {
                            return null;
                          }

                          return specGroup[
                            coilType === "3D" ? "specs3D" : "specs2D"
                          ].map((spec, index) => (
                            <tr key={`${specGroup.softness}-${index}`}>
                              {index === 0 && (
                                <td
                                  rowSpan={
                                    specGroup[
                                      coilType === "3D" ? "specs3D" : "specs2D"
                                    ].length
                                  }
                                  className="softness-cell"
                                >
                                  {specGroup.softness}
                                </td>
                              )}
                              <td>{spec.catalogNo}</td>
                              <td>{spec.loopDia}</td>
                              <td>{spec.length}</td>
                              <td>{spec.coilStructure}</td>
                            </tr>
                          ));
                        })}
                      </tbody>
                    </table>
                  </div>
                </>
              ) : selectedProduct === "neurocath-plus" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Outer Diameter</th>
                        <th>Inner Diameter</th>
                        <th>Length</th>
                        <th>Type</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products[selectedProduct].specs.map((spec, index) => (
                        <motion.tr
                          key={spec.size}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: index * 0.08 }}
                        >
                          <td>{spec.size}</td>
                          <td>{spec.innerDiameter}</td>
                          <td>{spec.length}</td>
                          <td>{spec.shape}</td>
                        </motion.tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ) : selectedProduct === "neuro-cath-support" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>PRODUCT NAME</th>
                        <th>Outer Diameter (O.D.)</th>
                        <th>Inner Diameter (I.D.)</th>
                        <th>Length</th>
                        <th>Reference</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>Distal Access Catheter</td>
                        <td>5F</td>
                        <td>0.058"</td>
                        <td>115 cm</td>
                        <td>MCSUP5F115</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter Multipurpose 25</td>
                        <td>5F</td>
                        <td>0.058"</td>
                        <td>115 cm</td>
                        <td>MCSUP5F115MP</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter</td>
                        <td>6F</td>
                        <td>0.071"</td>
                        <td>115 cm</td>
                        <td>MCSUP6F115</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter Multipurpose 25</td>
                        <td>6F</td>
                        <td>0.071"</td>
                        <td>115 cm</td>
                        <td>MCSUP6F115MP</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter</td>
                        <td>5F</td>
                        <td>0.058"</td>
                        <td>125 cm</td>
                        <td>MCSUP5F125</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter Multipurpose 25</td>
                        <td>5F</td>
                        <td>0.058"</td>
                        <td>125 cm</td>
                        <td>MCSUP5F125MP</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter</td>
                        <td>6F</td>
                        <td>0.071"</td>
                        <td>125 cm</td>
                        <td>MCSUP6F125</td>
                      </tr>
                      <tr>
                        <td>Distal Access Catheter Multipurpose 25</td>
                        <td>6F</td>
                        <td>0.071"</td>
                        <td>125 cm</td>
                        <td>MCSUP6F125MP</td>
                      </tr>
                    </tbody>
                  </table>
                </>
              ) : selectedProduct === "microcatheter" ? (
                <>
                  <div className="coil-type-selector">
                    {microcatheterVariants.map((variant) => (
                      <button
                        key={variant.key}
                        className={`coil-type-button ${
                          microVariant === variant.key ? "active" : ""
                        }`}
                        onClick={() => setMicroVariant(variant.key)}
                      >
                        {variant.label}
                      </button>
                    ))}
                  </div>

                  {microcatheterSpecs[microVariant] &&
                  microcatheterSpecs[microVariant].length > 0 ? (
                    <table>
                      <thead>
                        <tr>
                          <th>Item Number</th>
                          <th>Outer Diameter (O.D.)</th>
                          <th>Inner Diameter (I.D.)</th>
                          <th>Working Length</th>
                        </tr>
                      </thead>
                      <tbody>
                        {microcatheterSpecs[microVariant].map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.itemNumber}</td>
                            <td>{row.outerDiameter}</td>
                            <td>{row.innerDiameter}</td>
                            <td>{row.workingLength}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <div style={{ padding: "1rem", color: "#666" }}>
                      Specifications for {microcatheterVariants.find((v) => v.key === microVariant)?.label || "this variant"} will be added soon.
                    </div>
                  )}
                </>
              ) : selectedProduct === "neurosheath" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>5F (0.76" I.D. , .095" O.D.)</th>
                        <th>6F(.087" I.D., .108" O.D.)</th>
                        <th>7F (.101" I.D., .122" O.D.)</th>
                        <th>8F(.115" I.D., .134" O.D.)</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products[selectedProduct].specs && products[selectedProduct].specs.length > 0 ? (
                        products[selectedProduct].specs.map((row, idx) => (
                          <tr key={idx}>
                            <td>{row.productName}</td>
                            <td>{row.f5}</td>
                            <td>{row.f6}</td>
                            <td>{row.f7}</td>
                            <td>{row.f8}</td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td colSpan="5" style={{ textAlign: 'center', color: '#666' }}>
                            Specifications will be added soon.
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </>
              ) : selectedProduct === "neuro-soft" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>Tip Feature</th>
                        <th>Length</th>
                        <th>Reference</th>
                      </tr>
                    </thead>
                    <tbody>
                      {products[selectedProduct].specs.map((row, idx) => (
                        <tr key={idx}>
                          <td>{row.productName}</td>
                          <td>{row.tipFeature}</td>
                          <td>{row.length}</td>
                          <td>{row.reference}</td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </>
              ) : selectedProduct === "angio-clean" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>Product Name</th>
                        <th>4F (I.D. 1.05 / O.D. 1.40)</th>
                        <th>5F (I.D. 1.14 / O.D. 1.68)</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr><td>VERTEBRAL 100 CM HYDROPHILIC</td><td>DC4F-VER100</td><td>DC5F-VER100</td></tr>
                      <tr><td>VERTEBRAL 125 CM HYDROPHILIC</td><td>DC4F-VER125</td><td>DC5F-VER125</td></tr>
                      <tr><td>RENAL DOUBLE CURVE 65 CM HYDROPHILIC</td><td>DC4F-RDC065</td><td>DC5F-RDC065</td></tr>
                      <tr><td>RENAL DOUBLE CURVE 100 CM HYDROPHILIC</td><td>DC4F-RDC100</td><td>DC5F-RDC100</td></tr>
                      <tr><td>COBRA 1 65 CM HYDROPHILIC</td><td>DC4F-COB1065</td><td>DC5F-COB1065</td></tr>
                      <tr><td>COBRA 1 100 CM HYDROPHILIC</td><td>DC4F-COB1100</td><td>DC5F-COB1100</td></tr>
                      <tr><td>COBRA 2 65 CM HYDROPHILIC</td><td>DC4F-COB2065</td><td>DC5F-COB2065</td></tr>
                      <tr><td>COBRA 2 100 CM HYDROPHILIC</td><td>DC4F-COB2100</td><td>DC5F-COB2100</td></tr>
                      <tr><td>COBRA 3 65 CM HYDROPHILIC</td><td>DC4F-COB3065</td><td>DC5F-COB3065</td></tr>
                      <tr><td>COBRA 3 100 CM HYDROPHILIC</td><td>DC4F-COB3100</td><td>DC5F-COB3100</td></tr>
                      <tr><td>SHEPHERD 1 65 CM HYDROPHILIC</td><td>DC4F-SHP065</td><td>DC5F-SHP065</td></tr>
                      <tr><td>SHEPHERD 2 65 CM HYDROPHILIC</td><td>DC4F-SHP2065</td><td>DC5F-SHP2065</td></tr>
                      <tr><td>SIMMONS 1 80 CM HYDROPHILIC</td><td>DC4F-SIM180</td><td>DC5F-SIM180</td></tr>
                      <tr><td>SIMMONS 1 100 CM HYDROPHILIC</td><td>DC4F-SIM1100</td><td>DC5F-SIM1100</td></tr>
                      <tr><td>SIMMONS 1 125 CM HYDROPHILIC</td><td>DC4F-SIM1125</td><td>DC5F-SIM1125</td></tr>
                      <tr><td>SIMMONS 2 80 CM HYDROPHILIC</td><td>DC4F-SIM280</td><td>DC5F-SIM280</td></tr>
                      <tr><td>SIMMONS 2 100 CM HYDROPHILIC</td><td>DC4F-SIM2100</td><td>DC5F-SIM2100</td></tr>
                      <tr><td>SIMMONS 2 125 CM HYDROPHILIC</td><td>DC4F-SIM2125</td><td>DC5F-SIM2125</td></tr>
                      <tr><td>SIMMONS 3 100 CM HYDROPHILIC</td><td>DC4F-SIM3100</td><td>DC5F-SIM3100</td></tr>
                      <tr><td>SIMMONS 3 125 CM HYDROPHILIC</td><td>DC4F-SIM3125</td><td>DC5F-SIM3125</td></tr>
                      <tr><td>HEADHUNTER 1 100 CM HYDROPHILIC</td><td>DC4F-HH1100</td><td>DC5F-HH1100</td></tr>
                      <tr><td>HEADHUNTER 1 125 CM HYDROPHILIC</td><td>DC4F-HH1125</td><td>DC5F-HH1125</td></tr>
                      <tr><td>HEADHUNTER 3 100 CM HYDROPHILIC</td><td>DC4F-HH3100</td><td>DC5F-HH3100</td></tr>
                      <tr><td>HEADHUNTER 3 125 CM HYDROPHILIC</td><td>DC4F-HH3125</td><td>DC5F-HH3125</td></tr>
                      <tr><td>MANI - 100 CM HYDROPHILIC</td><td>DC4F-MANI100</td><td>DC5F-MANI100</td></tr>
                      <tr><td>BERENSTEIN 45 CM / 65 CM HYDROPHILIC</td><td>DC4F-BRN045</td><td>DC5F-BRN065</td></tr>
                      <tr><td>STRAIGHT 100 CM HYDROPHILIC</td><td>DC4F-STR100</td><td>DC5F-STR100</td></tr>
                      <tr><td>STRAIGHT 125 CM HYDROPHILIC</td><td>DC4F-STR125</td><td>DC5F-STR125</td></tr>
                      <tr><td>MULTI PURPOSE C (MP C) 100 CM HYDROPHILIC</td><td>DC4F-MPC100</td><td>DC5F-MPC100</td></tr>
                      <tr><td>MULTI-PURPOSE D (MP D) 100 CM HYDROPHILIC</td><td>DC4F-MPD100</td><td>DC5F-MPD100</td></tr>
                      <tr><td>J CURVE 1 65 CM HYDROPHILIC</td><td>DC4F-JK165</td><td>DC5F-JK165</td></tr>
                      <tr><td>J CURVE 2 65 CM HYDROPHILIC</td><td>DC4F-JK265</td><td>DC5F-JK265</td></tr>
                      <tr><td>BENTSON 1 - 100 CM HYDROPHILIC</td><td>DC4F-BNT100</td><td>DC5F-BNT100</td></tr>
                      <tr><td>BENTSON 2 - 100 CM HYDROPHILIC</td><td>DC4F-BNT2100</td><td>DC5F-BNT2100</td></tr>
                      <tr><td>BENTSON 3 - 100 CM HYDROPHILIC</td><td>DC4F-BNT3100</td><td>DC5F-BNT3100</td></tr>
                      <tr><td>NEWTON HN3 - 100 CM HYDROPHILIC</td><td>DC4F-NEW3100</td><td>DC5F-NEW3100</td></tr>
                      <tr><td>NEWTON HN4 - 100 CM HYDROPHILIC</td><td>DC4F-NEW4100</td><td>DC5F-NEW4100</td></tr>
                    </tbody>
                  </table>
                </>
              ) : selectedProduct === "hydra" ? (
                <>
                  <table>
                    <thead>
                      <tr>
                        <th>PRODUCT</th>
                        <th>FEATURE</th>
                        <th>REFERENCE 180 cm</th>
                        <th>REFERENCE 260 cm</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>0.035" HYDROPHILIC NITINOL GUIDE WIRE Ø 0.035" / 0.89 MM</td>
                        <td>STRAIGHT STANDARD</td>
                        <td>GW-035HN-180S</td>
                        <td>GW-035HN-260S</td>
                      </tr>
                      <tr>
                        <td>0.035" HYDROPHILIC NITINOL GUIDE WIRE Ø 0.035" / 0.89 MM</td>
                        <td>STRAIGHT STIFF</td>
                        <td>GW-035HN-180SST</td>
                        <td>GW-035HN-260SST</td>
                      </tr>
                      <tr>
                        <td>0.035" HYDROPHILIC NITINOL GUIDE WIRE Ø 0.035" / 0.89 MM</td>
                        <td>ANGLED STANDARD</td>
                        <td>GW-035HN-180A</td>
                        <td>GW-035HN-260A</td>
                      </tr>
                      <tr>
                        <td>0.035" HYDROPHILIC NITINOL GUIDE WIRE Ø 0.035" / 0.89 MM</td>
                        <td>ANGLED STIFF</td>
                        <td>GW-035HN-180AST</td>
                        <td>GW-035HN-260AST</td>
                      </tr>
                    </tbody>
                  </table>
                </>
              ) : null }

              
            </motion.div>
          )} 

          {activeTab === "features" && (
            <motion.div
              key={selectedProduct + "-features"}
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.3 }}
              className="features-section"
            >
              {selectedProduct === "proender" && (
                <motion.div
                  className="features-cover"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={proender5} alt="Proender Features" />
                </motion.div>
              )}
              {selectedProduct === "neuro-cath-support" && (
                <motion.div
                  className="features-cover support-cover"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <img
                    src={neuroCathSupport3}
                    alt="Neuro-Cath Support Features"
                  />
                </motion.div>
              )}
              {selectedProduct === "neurocath-plus" && (
                <motion.div
                  className="features-cover support-cover neurocath-cover"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={neurocathPlus2} alt="Neurocath Plus Features" />
                </motion.div>
              )}
              {selectedProduct === "perrdenser" && (
                <motion.div
                  className="features-cover"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={perdenser7} alt="Perdenser Features" />
                </motion.div>
              )}
              {selectedProduct === "perfiller" && (
                <motion.div
                  className="features-cover"
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.5 }}
                >
                  <img src={perfiller4} alt="Perfiller Features" />
                </motion.div>
              )}
              {/* neurocath-plus banner removed per request; Hydrophilic card will show the image horizontally */}
              {selectedProduct === "neurocath-plus" ? (
                <>
                  {/* Row with non-fullwidth feature cards (Hydrophilic & Optimized Aspiration) centered */}
                  <div className="neuro-features-row">
                    {products[selectedProduct].features
                      .filter((f) => !f.fullWidth)
                      .map((feature, idx) => (
                        <motion.div
                          key={idx}
                          className={`feature-card neuro-small-card`}
                          initial={{ opacity: 0, y: 20 }}
                          animate={{ opacity: 1, y: 0 }}
                          transition={{ delay: idx * 0.1 }}
                        >
                          {feature.image && (
                            <div className={"feature-image " + (feature.image === neurocathPlus1 ? 'horizontal' : '')}>
                              <img src={feature.image} alt={feature.title} />
                            </div>
                          )}
                          <h3>{titleCase(feature.title)}</h3>
                          <p>{feature.description}</p>
                          
                        </motion.div>
                      ))}
                  </div>

                  {/* Render full-width feature cards (Flexible Distal Segment) below */}
                    {products[selectedProduct].features
                    .filter((f) => f.fullWidth)
                    .map((feature, idx) => (
                      <motion.div
                        key={`full-${idx}`}
                        className="feature-card"
                        style={{ gridColumn: '1 / -1', marginTop: '1rem' }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.1 }}
                      >
                        {feature.image && (
                          <div className={`feature-image full ${feature.imageContain ? 'contain' : ''}`}>
                            <img src={feature.image} alt={feature.title} />
                          </div>
                        )}
                        <h3>{feature.title}</h3>
                        <p>{feature.description}</p>
                        
                      </motion.div>
                    ))}
                </>
              ) : selectedProduct === "neurosheath" ? (
                <>
                  {/* Render full-width hero first */}
                  {products[selectedProduct].features
                    .filter((f) => f.fullWidth)
                    .map((feature, idx) => (
                      <motion.div
                        key={`ns-full-${idx}`}
                        className="feature-card"
                        style={{ gridColumn: '1 / -1', marginTop: '1rem' }}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: idx * 0.1 }}
                      >
                        {feature.image && (
                          <div className={`feature-image full ${feature.imageContain ? 'contain' : ''}`}>
                            <img src={feature.image} alt={feature.title} />
                          </div>
                        )}
                        <h3>{feature.title}</h3>
                        {feature.description && <p>{feature.description}</p>}
                        
                      </motion.div>
                    ))}

                  {/* Two rows of two cards each */}
                  {(() => {
                    const cards = products[selectedProduct].features.filter((f) => !f.fullWidth).slice(0, 4);
                    const rows = [cards.slice(0, 2), cards.slice(2, 4)];
                    return rows.map((row, rIdx) => (
                      <div key={`ns-row-${rIdx}`} style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: '1rem', marginTop: rIdx === 0 ? '1rem' : '0.5rem' }}>
                        {row.map((feature, index) => (
                          <motion.div
                            key={`ns-card-${rIdx}-${index}`}
                            className="feature-card neurosheath-small-card"
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                          >
                            {feature.image && (
                              <div className={`feature-image ${feature.imageSmall ? 'small' : (feature.imageMedium ? 'medium' : '')}`}>
                                <img src={feature.image} alt={feature.title} />
                              </div>
                            )}
                            <h3>{titleCase(feature.title)}</h3>
                            <p>{feature.description}</p>
                            
                          </motion.div>
                        ))}
                      </div>
                    ));
                  })()}
                </>
              ) : (
                <div className={`features-grid ${selectedProduct === 'angio-clean' ? 'angio-clean-features' : ''}`}>
                  {products[selectedProduct].features.map((feature, index) => {
                    const cardStyle = {
                      ...(feature.fullWidth ? { gridColumn: '1 / -1', textAlign: 'center' } : {}),
                      ...(feature.centered
                        ? {
                            gridColumn: '1 / -1',
                            justifySelf: 'center',
                            maxWidth: '520px',
                            width: '100%',
                            margin: '0 auto',
                          }
                        : {}),
                    };

                    return (
                      <motion.div
                        key={index}
                        className={`feature-card ${feature.compact ? 'compact' : ''} ${feature.alignBottom ? 'align-bottom' : ''}`}
                        style={Object.keys(cardStyle).length ? cardStyle : undefined}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ delay: index * 0.1 }}
                      >
                        {feature.image &&
                          feature.image !== perdenser7 &&
                          feature.image !== perfiller4 && (
                            <div
                              className={`feature-image ${
                                feature.fullWidth
                                  ? 'full'
                                  : feature.imageHorizontal
                                  ? 'horizontal'
                                  : feature.imageSmall
                                  ? 'small'
                                  : feature.imageMedium
                                  ? 'medium'
                                  : ''
                              } ${feature.imageContain ? 'contain' : ''} ${feature.imageCentered ? 'centered' : ''}`}
                              style={feature.imageHeight ? { height: `${feature.imageHeight}px`, maxHeight: `${feature.imageHeight}px` } : undefined}
                            >
                              <img src={feature.image} alt={feature.title} />
                            </div>
                          )}
                        <h3>{titleCase(feature.title)}</h3>
                        <p>{feature.description}</p>
                        
                      </motion.div>
                    );
                  })}
                </div>
              )}
            </motion.div>
          )}
        </div>

        <motion.div
          className="cta-section"
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
        >
          <div className="cta-content">
            <h2>For More Information</h2>
            <p>
              Please contact us for detailed information about our products and
              technical documents.
            </p>
            <Link to="/contact" className="cta-button">
              Contact Us
            </Link>
          </div>
        </motion.div>
      </section>
    </div>
  );
}

export default Products;
